import NextLink from 'next/link';
import { ComponentProps, useContext } from 'react';
import { TransitionContext } from '../providers/transition';

export function Link(props: ComponentProps<typeof NextLink>) {
  const { onStart } = useContext(TransitionContext);

  const { href, onClick } = props;

  return (
    <NextLink
      {...props}
      onClick={(...args) => {
        if (args[0]?.nativeEvent?.ctrlKey) {
          return;
        }
        onStart(href.toString());
        onClick?.(...args);
      }}
    />
  );
}
